import { render, staticRenderFns } from "./ProjectWorkspaceSwitcher.vue?vue&type=template&id=e6d79e7e"
import script from "./ProjectWorkspaceSwitcher.vue?vue&type=script&lang=ts"
export * from "./ProjectWorkspaceSwitcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports